import React from 'react';
import { Quote as QuoteIcon } from 'lucide-react';
interface QuoteBlockProps {
  quote: string;
  author: string;
  bgClass?: string;
  textClass?: string;
  accentClass?: string;
  authorClass?: string;
  imageSrc?: string;
  imageAlt?: string;
}
export function QuoteBlock({
  quote,
  author,
  bgClass = 'bg-rose-100',
  textClass = 'text-charcoal',
  accentClass = 'text-rose-600',
  authorClass = 'text-charcoal-50',
  imageSrc,
  imageAlt = ''
}: QuoteBlockProps) {
  return <section className={`relative ${bgClass} py-24 px-6 overflow-hidden`} data-id="element-367" data-mp="3w2x8edmj1oc">
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-368" data-mp="3tzzt9a5669l">
        <QuoteIcon size={36} strokeWidth={1} className={`${accentClass} mx-auto mb-6`} aria-hidden="true" data-id="element-369" data-mp="8o47xvv58kc9" />
        <p className={`font-serif text-3xl md:text-4xl ${textClass} italic leading-snug mb-5`} data-id="element-370" data-mp="dlcu07jex8is">
          {quote}
        </p>
        <p className={`text-sm tracking-widest uppercase ${authorClass}`} data-id="element-371" data-mp="ij5woqlibkeb">
          {author}
        </p>
      </div>
      {imageSrc && <div className="absolute inset-x-0 bottom-0 h-32 md:h-48 opacity-30 pointer-events-none" data-id="element-372" data-mp="1x949al8kxf5i">
          <img src={imageSrc} alt={imageAlt} className="w-full h-full object-cover" data-id="element-373" data-mp="1s8yq7tgdl0z1" />
        </div>}
    </section>;
}